import { render, staticRenderFns } from "./UfDetailDrawer.vue?vue&type=template&id=035144d6&scoped=true"
import script from "./UfDetailDrawer.vue?vue&type=script&lang=js"
export * from "./UfDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./UfDetailDrawer.vue?vue&type=style&index=0&id=035144d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035144d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('035144d6')) {
      api.createRecord('035144d6', component.options)
    } else {
      api.reload('035144d6', component.options)
    }
    module.hot.accept("./UfDetailDrawer.vue?vue&type=template&id=035144d6&scoped=true", function () {
      api.rerender('035144d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/statusMonitoringAndWarning/cmp/UfDetailDrawer.vue"
export default component.exports